export default "__VITE_ASSET__vb3yBgqe__"